/**
 * Sasha Home Page Module
 */

// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

// Afidium
import { SashaHomeComponent } from "./sasha-home.component";
import { CardModule } from 'libraries/ui_card/card.module';
import { ProcessingResultContainerModule } from "../processing-search-result/components/processing-result-container/processing-result-container.module";
import { ProcessingResourceModule } from 'app_sasha/shared/resources/processings/processingResource.module';
import { PermissionModule } from "libraries/permission/permission.module";
import { BookingMainModule } from '../../shared/components/booking-main/booking-main.module';
import { ViewsModule } from 'libraries/view/views.module';
import { SashaSideLinksModule } from "app_sasha/pages/sasha-home/components/sasha-side-links/sasha-side-links.module";

@NgModule({
    imports: [
        CommonModule,
        ViewsModule,
        CardModule,
        ProcessingResultContainerModule,
        ProcessingResourceModule,
        PermissionModule,
        BookingMainModule,
        SashaSideLinksModule,
        RouterModule,
    ],
    declarations: [
        SashaHomeComponent,
    ],
})
export class SashaHomeModule { }
